var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Slice',[_c('b-container',{staticClass:"slice-text",attrs:{"fluid":""}},[_c('b-container',{staticClass:"wrapper"},[_c('TextView',{attrs:{"text":_vm.slice.primary.text}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }